import {Injectable, InjectionToken} from '@angular/core';
import {UserContextService} from './user-context.service';
import {LoginResponseModelNew} from '../../modules/auth/models/login-response-model-new';
import {WhoAmIHttpService} from './who-am-i-http.service';
import {LocalStorageService} from './local-storage.service';
import {CredentialsManager} from './credentils.manager';

@Injectable({
    providedIn: 'root'
})
export class AppAuthenticationAdapterService {
    constructor(
        private userContextService: UserContextService,
        private localStorageService: LocalStorageService,
        private credentialsManager: CredentialsManager) {
    }


    finishOldLogout() {
        this.localStorageService.removeAppPortalSecurityToken();
        this.localStorageService.removeDealerPortalSecurityToken();

        this.userContextService.removeUserDetails();
        this.credentialsManager.removeCredentials();
    }
}
